<template>
    <div>
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>
        <div class="container">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="名字:">
                    <el-input class="s-input" v-model="queryParams.username" placeholder="请输入名字" clearable></el-input>
                </el-form-item>
                <el-form-item label="内容:">
                    <el-input class="s-input" v-model="queryParams.content" placeholder="请输入内容" clearable></el-input>
                </el-form-item>

                <div style="float: right">
                    <el-button type="primary" @click="changeQuery()">搜索</el-button>
                </div>
            </el-form>
            <!-- 表格内容 -->
            <el-table v-loading="loading" element-loading-text="数据加载中" :cell-style="cellstyle" stripe border :data="pageInfo.list" class="el-table" style="margin-top: 30px;">
                <el-table-column label="id" prop="id" align="center" width="100"></el-table-column>
                <el-table-column label="名字" prop="username" align="center" width="200"></el-table-column>
                <el-table-column label="内容" prop="content" align="center"></el-table-column>
                <el-table-column label="信息模块" prop="module" align="center" width="200"></el-table-column>
                <el-table-column label="操作时间" prop="ctime" align="center" width="200"></el-table-column>
            </el-table>
            <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum" />
        </div>
    </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import Pagination from '@/components/Pagination';
import { request } from '@/common/request';
import { deal } from '@/common/main';
export default {
    name: 'StoreInfo',
    components: {
        Breadcrumb,
        Pagination
    },
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            menuList: ['系统', '后台日志'],
            loading: false,
            queryParams: {
                name: '',
                page: 1,
                pagesize: 10,
                platform: 'admin'
            },
            pageInfo: {},
            addVisible: false,
            title: '添加热词',
            form: {
                name: '',
                state: null,
                time: null
            },

        };
    },
    created() {
        this.loadData();
    },
    methods: {
        cellstyle() {
            return 'text-align: center';
        },
        //获取后台日志列表
        loadData() {
            this.loading = true;
            let _this = this
            request.get('/log/list', this.queryParams).then(ret => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.pageInfo = ret.data;
                    this.pageInfo.list = ret.data.list
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        //分页
        changeQuery() {
            this.queryParams.page = 1;
            this.loadData();
        },
        refreshPageSize(val) {
            this.queryParams.pagesize = val;
            this.loadData();
        },
        refreshPageNum(val) {
            this.queryParams.page = val;
            this.loadData();
        }
    }
};
</script>

<style scoped>
</style>